import * as yup from 'yup';

export const emailTemplateSchema = yup.object().shape({
  id: yup.number().optional(),
  oid: yup.number().optional(),
  userId: yup.number().optional(),
  templateName: yup.string().required('Template name is required'),
  templateBody: yup.string().required('Template body is required'),
  templateSubject: yup.string().required('Template subject is required'),
  dynamicTemplate: yup.boolean().optional(),
  tags: yup.array().of(yup.string()).optional(),
});

export const setDefaultValues = (template, oid, userId, removeParagraphTags) => {
  return {
    id: template?.id,
    oid: template?.oid || oid,
    userId: template?.userId || userId,
    templateName: template?.templateName,
    templateBody: template?.templateBody ? removeParagraphTags(template?.templateBody) : '',
    templateSubject: template?.templateSubject,
    dynamicTemplate: !!template?.dynamicTemplate,
    tags: template?.tags || [],
  };
};
